import router from "@/router";
import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import { AuthService } from "@/common/api/services/AuthService";
import { ADMIN_ROLE } from "@/common/constant";

@Module({ namespaced: true })
export default class AuthModule extends VuexModule {
  token = localStorage.getItem("token") || "";
  expiredAt = "";
  role = "";
  userLogging: any;

  get getLoggingUser(): string {
    return this.userLogging;
  }

  get isAdmin(): boolean {
    return this.userLogging && this.userLogging.role == ADMIN_ROLE;
  }

  @Mutation
  setToken(token: string): void {
    this.token = token;
    localStorage.setItem("token", token);
  }
  @Mutation
  setExpiredAt(time: string): void {
    this.expiredAt = time;
  }
  @Mutation
  setRole(role: string): void {
    this.role = role;
  }
  @Mutation
  setUserLogging(user): void {
    this.userLogging = user;
  }

  @Action({ rawError: true })
  updateToken(token: string): void {
    this.context.commit("setToken", token);
  }
  @Action
  updateExpiredAt(time: string): void {
    this.context.commit("setExpiredAt", time);
  }
  @Action
  updateRole(role: string): void {
    this.context.commit("setRole", role);
  }

  @Action
  setUser(user) {
    this.context.commit("setUserLogging", user);
  }

  @Action
  async fetchCurrentUser(): Promise<void> {
    try {
      const response = await AuthService.me({});

      this.context.commit("setUserLogging", response.data.user);
    } catch {
      this.context.commit("setToken", "");
      this.context.commit("setExpiredAt", "");
      this.context.commit("setUserLogging", null);
      router.push({ name: "login" });
    }
  }

  @Action
  logout(redirect = true): void {
    this.context.commit("setToken", "");
    this.context.commit("setExpiredAt", "");
    this.context.commit("setUserLogging", null);
    redirect && router.push({ name: "login" });
  }
}

// export default getModule(AuthModule);
